import { GetApiPublicTabletBarbersQueryParamsServiceTypeEnum } from '@barbershop/api/customer'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { ModeStep } from '@/pages/tablet/create-booking-page'

const ModeSearchSchema = z.object({
    service_id: z.number(),
    service_type: z.enum(GetApiPublicTabletBarbersQueryParamsServiceTypeEnum),
})

export const Route = createFileRoute('/_tablet-layout/branch/$id/create/_wizard/mode')({
    component: ModeStep,
    validateSearch: ModeSearchSchema,
})
